const error = require('./error');
const success = require('./success');
const { errors, billetType } = require('@transfeeradev/api-enums');
const moment = require('@transfeeradev/moment');
const { DateService } = require('@transfeeradev/api-services');
const SimpleBarcode = require('./SimpleBarcode');
const GetTypeService = require('../services/GetTypeService');
const DueDate = require('./DueDate');

class PaymentDate {
  constructor(
    billet,
    options = {
      disallowOverdue: false
    }
  ) {
    if (!billet.payment_date || !billet.barcode) {
      throw new Error('payment date validation require payment_date and barcode values to do your validation');
    }

    this._billet = Object.assign({}, billet);
    this._options = options;
    this._type = GetTypeService.get(this._billet.barcode);
  }

  validate() {
    const dataValidation = this._dataValidation();

    if (!dataValidation.isValid) {
      return dataValidation;
    }

    const beforeCurrentDateValidation = this._beforeCurrentDate();

    if (!beforeCurrentDateValidation.isValid) {
      return beforeCurrentDateValidation;
    }

    const hourValidation = this._hour();

    if (!hourValidation.isValid) {
      return hourValidation;
    }

    let dueDateValidation = {
      isValid: true
    };

    if (this._type === billetType.SIMPLE) {
      const barcodeData = new SimpleBarcode(this._billet).getData();

      if (barcodeData.dueDate) {
        dueDateValidation = this._dueDate(barcodeData);
      }

      if (!dueDateValidation.isValid) {
        return dueDateValidation;
      }
    }

    const businessDayValidation = this._businessDay();

    if (!businessDayValidation.isValid) {
      return businessDayValidation;
    }
    return success;
  }

  _beforeCurrentDate() {
    if (moment(this._billet.payment_date).isBefore(moment(), 'day')) {
      return error(errors.ptBr.bil.PAYMENT_DATE_BEFORE_CURRENT_DATE, 'payment_date');
    }

    return success;
  }

  _hour() {
    const paymentDate = moment(this._billet.payment_date);
    const today = moment();

    if (paymentDate.isSame(today, 'day')) {
      const start = moment('00:00:00', 'HH:mm:ss');
      let end;

      // TODO: 'if' can be removed when past this date and keep end = 17:58h
      if (today.isSameOrAfter(moment('2023-02-01'), 'day')) {
        end = moment('17:58:00', 'HH:mm:ss');
      } else {
        end = moment('19:00:00', 'HH:mm:ss');
      }
      const IS_SAME_OR_BETWEEN_SYMBOL = '[]';

      if (!moment().isBetween(start, end, null, IS_SAME_OR_BETWEEN_SYMBOL)) {
        return error(errors.ptBr.bil.INVALID_PROCESSING_HOUR, 'payment_date');
      }
    }

    return success;
  }

  _dueDate(barcodeData) {
    const dueDate = moment(barcodeData.dueDate);
    const paymentDate = moment(this._billet.payment_date);
    const isDueDateABusinessDay = moment(dueDate).isBusinessDay() && !DueDate.isLastBusinessDayOfYear(dueDate);
    const isFirstBusinessDayAfterDueDate = paymentDate.isSame(moment(dueDate).nextBusinessDay(), 'day');

    if (!isDueDateABusinessDay && isFirstBusinessDayAfterDueDate) {
      return success;
    }

    if (this._options.disallowOverdue && paymentDate.isAfter(dueDate, 'day')) {
      return error(errors.ptBr.bil.IS_AFTER_DUE_DATE_ERROR_MESSAGE, 'payment_date');
    }

    if (!this._options.disallowOverdue) {
      const isOverdue = new DueDate(this._billet).isOverdue();

      if (isOverdue && paymentDate.isAfter(moment(), 'day')) {
        return error(errors.ptBr.bil.CANT_SCHEDULE_OVERDUE_BILLET, 'payment_date');
      }
    }

    return success;
  }

  _businessDay() {
    if (
      !moment(this._billet.payment_date).isBusinessDay() ||
      DueDate.isLastBusinessDayOfYear(this._billet.payment_date)
    ) {
      return error(errors.ptBr.bil.BUSINESS_DAY, 'payment_date');
    }

    return success;
  }

  _dataValidation() {
    this._billet.payment_date = DateService.getFormatted(this._billet.payment_date);

    if (!this._billet.payment_date) {
      return error(errors.ptBr.bil.PAYMENT_DATE_WRONG_DATE);
    }

    return success;
  }
}

module.exports = PaymentDate;
